module.exports = {
      id: "line-arrow-prev-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#line-arrow-prev",
      toString: function () {
        return this.url;
      }
    }